const updateDecisions = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { liveData: { decisions = {} } = {} } = action?.data || {};
        return decisions;
    }

    return state;
};

export default updateDecisions;
